import { call, put, takeEvery } from 'redux-saga/effects';
import {
  CASE_FETCH_EXHIBIT_CHANGES_BEGIN,
  CASE_FETCH_EXHIBIT_CHANGES_SUCCESS,
  CASE_FETCH_EXHIBIT_CHANGES_FAILURE,
  CASE_FETCH_EXHIBIT_CHANGES_DISMISS_FEEDBACK,
} from './constants';
import {
  createPromiseAction,
  resolvePromiseAction,
  rejectPromiseAction,
} from '@adobe/redux-saga-promise';
import api from 'common/api';
import { withCurrentCaseId } from 'common/selectors';

export const fetchExhibitChanges = createPromiseAction(
  CASE_FETCH_EXHIBIT_CHANGES_BEGIN,
  (fileId) => ({ fileId }),
);

export function dismissFetchExhibitChangesFeedback() {
  return {
    type: CASE_FETCH_EXHIBIT_CHANGES_DISMISS_FEEDBACK,
  };
}

export function* doFetchExhibitChanges(action) {
  const {
    payload: { fileId, caseId },
  } = action;

  const res = yield call(api.get, `/cases/${caseId}/files/${fileId}/exhibit-changes`);

  if (res && res.error) {
    yield put({
      type: CASE_FETCH_EXHIBIT_CHANGES_FAILURE,
      feedback: {
        message: 'feedback.fetchExhibitChangesFailure',
        params: { fileId },
        error: res.error,
        retryAction: action,
      },
      fileId,
    });
    return yield call(rejectPromiseAction, action, res.error);
  }

  yield put({
    type: CASE_FETCH_EXHIBIT_CHANGES_SUCCESS,
    data: res,
  });
  return yield call(resolvePromiseAction, action, res);
}

export function* watchFetchExhibitChanges() {
  yield takeEvery(fetchExhibitChanges, withCurrentCaseId(doFetchExhibitChanges));
}

export function reducer(state, action) {
  switch (action.type) {
    case CASE_FETCH_EXHIBIT_CHANGES_BEGIN + '.TRIGGER':
      return {
        ...state,
        fetchExhibitChangesPending: true,
        fetchExhibitChangesFeedback: null,
      };

    case CASE_FETCH_EXHIBIT_CHANGES_SUCCESS:
      return {
        ...state,
        fetchExhibitChangesPending: false,
        fetchExhibitChangesFeedback: action.feedback,
        exhibitChangesData: action.data,
      };

    case CASE_FETCH_EXHIBIT_CHANGES_FAILURE:
      return {
        ...state,
        fetchExhibitChangesPending: false,
        fetchExhibitChangesFeedback: action.feedback,
      };

    case CASE_FETCH_EXHIBIT_CHANGES_DISMISS_FEEDBACK:
      return {
        ...state,
        fetchExhibitChangesFeedback: null,
      };

    default:
      return state;
  }
}
